import { BarChart3, Search } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface ComparisonEmptyStateProps {
  type: 'not-generated' | 'no-matches';
  onGenerate?: () => void;
  isGenerating?: boolean;
}

export function ComparisonEmptyState({
  type,
  onGenerate,
  isGenerating = false,
}: ComparisonEmptyStateProps) {
  if (type === 'no-matches') {
    return (
      <div className="rounded-lg border bg-muted/30 p-8 text-center">
        <Search className="mx-auto h-10 w-10 text-muted-foreground" />
        <h3 className="mt-4 text-lg font-medium">No Matching Products Found</h3>
        <p className="mt-2 text-sm text-muted-foreground">
          We couldn&apos;t find replacement products that match this policy&apos;s criteria. This
          may be because:
        </p>
        <ul className="mx-auto mt-3 max-w-md space-y-1 text-left text-sm text-muted-foreground">
          <li>- Current rates are already competitive</li>
          <li>- Owner age or jurisdiction limits available products</li>
          <li>- Account value is outside product premium ranges</li>
          <li>- Rate sheet data hasn&apos;t been ingested yet</li>
        </ul>
        <p className="mt-4 text-sm text-muted-foreground">
          Use the search or filters below to choose products from the full catalog.
        </p>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-dashed bg-muted/30 p-8 text-center">
      <BarChart3 className="mx-auto h-10 w-10 text-muted-foreground" />
      <h3 className="mt-4 text-lg font-medium">Generate Comparison</h3>
      <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
        Find replacement products that could improve this policy&apos;s rates, features, or
        surrender terms.
      </p>
      {onGenerate && (
        <Button className="mt-6" onClick={onGenerate} disabled={isGenerating}>
          {isGenerating ? 'Generating...' : 'Generate Comparison'}
        </Button>
      )}
    </div>
  );
}
